import { Box, Typography } from '@mui/material';
import {
    AddIcon,
    DeleteIcon,
    ExportCsvIcon,
    ImportCsvIcon,
    QrIcon,
    SearchIcon,
} from 'assets/icons';
import { IconRight } from 'assets/icons/icon-right';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TKeys } from 'utils/enums';

const AppHeaderLayout: React.FC<IAppHeaderLayoutProps> = (props) => {
    const { t } = useTranslation();
    const {
        onClickAddButton,
        onClickDeleteButton,
        onClickExportCsvButton,
        onClickImportCsvButton,
        onClickSearchButton,
        onClickPrevScreen,
        onClickSaveButton,
        onClickCompleteButton,
        onClickAddTaskButton, // 指示登録
        isShowDeleteButton = true,
        title = '',
        visibleExportCsvButton = false,
        visibleImportCsvButton = false,
        disableSaveButton = false,
        disableCompleteButton = false,
        onClickQrButton,
        visibleQrButton,
        isPrevent = false,
    } = props;

    const buttons = useMemo(
        () => [
            {
                label: TKeys.BTN000003,
                color: 'var(--color-ff0000)',
                icon: <DeleteIcon />,
                onClick: onClickDeleteButton,
                visible: isShowDeleteButton,
            },
            {
                label: TKeys.BTN000007,
                color: 'var(--color-00879e)',
                icon: <QrIcon />,
                onClick: onClickQrButton,
                visible: visibleQrButton,
            },
            {
                label: TKeys.BTN000001,
                color: 'var(--color-ebb02d)',
                icon: <AddIcon />,
                onClick: onClickAddButton,
                visible: !!onClickAddButton,
            },
            {
                label: TKeys.BTN000018,
                color: 'var(--color-ebb02d)',
                icon: <AddIcon />,
                onClick: onClickAddTaskButton,
                visible: !!onClickAddTaskButton,
            },
            {
                label: TKeys.BTN000002,
                color: 'var(--color-2281cc)',
                icon: <SearchIcon />,
                onClick: onClickSearchButton,
                visible: !!onClickSearchButton,
            },
            {
                label: TKeys.BTN000004,
                color: 'var(--color-4da1a9)',
                icon: <ImportCsvIcon />,
                onClick: onClickImportCsvButton,
                visible: visibleImportCsvButton,
            },
            {
                label: TKeys.BTN000005,
                color: 'var(--color-4da1a9)',
                icon: <ExportCsvIcon />,
                onClick: onClickExportCsvButton,
                visible: visibleExportCsvButton,
            },

            {
                label: TKeys.BTN000011,
                color: 'var(--color-ebb02d)',
                onClick: onClickSaveButton,
                visible: !!onClickSaveButton,
                disable: disableSaveButton,
            },
            {
                label: TKeys.BTN000012,
                color: 'var(--color-2281cc)',
                onClick: onClickCompleteButton,
                visible: !!onClickCompleteButton,
                disable: disableCompleteButton,
            },
        ],
        // eslint-disable-next-line
        [
            onClickDeleteButton,
            isShowDeleteButton,
            onClickAddButton,
            onClickSearchButton,
            onClickImportCsvButton,
            onClickExportCsvButton,
            onClickCompleteButton,
            onClickSaveButton,
            onClickAddTaskButton,
            visibleImportCsvButton,
            disableSaveButton,
            disableCompleteButton,
            onClickQrButton,
            visibleQrButton,
        ],
    );

    const renderButtonsWidget = () => {
        return buttons.map((btn, index) => {
            if (!btn.visible) return null;

            return (
                <Box
                    key={index}
                    component="button"
                    disabled={btn.disable}
                    onClick={btn.onClick}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        padding: '12px 16px',
                        backgroundColor: btn.color,
                        color: '#FFFFFF',
                        borderRadius: '8px',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        transition: '0.3s',
                        ':disabled': {
                            opacity: 0.7,
                        },
                    }}>
                    {btn.icon}
                    <Typography
                        variant="button"
                        sx={{
                            display: { xs: 'none', sm: 'none', md: 'block' },
                            textWrap: 'nowrap',
                        }}>
                        {t(btn.label)}
                    </Typography>
                </Box>
            );
        });
    };

    return (
        <Box
            sx={{
                margin: '20px 10px',
                fontFamily: 'Meiryo',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 2,
                }}>
                <Typography
                    sx={{
                        fontSize: '26px',
                        lineHeight: '20px',
                        letterSpacing: '0.25px',
                        color: 'var(--color-black)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        cursor: isPrevent ? 'pointer' : 'default',
                    }}
                    onClick={onClickPrevScreen}>
                    {isPrevent && <IconRight />}
                    {t(title)}
                </Typography>
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexWrap: 'nowrap',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: '10px',
                        height: '100%',
                    }}>
                    {renderButtonsWidget()}
                </Box>
            </Box>
        </Box>
    );
};

export { AppHeaderLayout };
